export default __webpack_public_path__ + "static/media/m1-1bg.531c4f30.png";